import type { QueryClient, UseQueryOptions } from 'react-query';

import logger from '@cash-web/shared/util-logger';

// Adapted from tanstack/query's ensureQueryData (available in v4+)
// https://tanstack.com/query/latest/docs/reference/QueryClient#queryclientensurequerydata
export async function ensureQueryData<T, TError = unknown>(
  queryClient: QueryClient,
  queryConfig: UseQueryOptions<T, TError>
): Promise<T | null> {
  const queryKey = queryConfig.queryKey
  const cached = queryKey ? queryClient.getQueryData<T>(queryKey) : undefined
  
  if (cached !== undefined) {
    void queryClient.prefetchQuery<T, TError, T>(queryConfig)
    return cached
  }

  try {
    return await queryClient.fetchQuery<T, TError, T>(queryConfig)
  } catch (e) {
    const error = e as Error
    logger.error(new Error(`Failed to fetch query [${String(queryKey)}]: ${error.message}`))
    return null
  }
}
